import { useContext } from 'react';
import { AppContext } from '@send-legacy-app/Context';

const useCurrentUser = () => {
  const { user } = useContext(AppContext);
  return [user.attributes];
};

export default useCurrentUser;
